import React from "react";
import banner from '../../images/promo/promo-banner.png'

const topSeller = {
    name: "Monitor ZUS230GMG",
    image: banner,
    features: [
        "165Hz refresh rate",
        "FullHD resolution",
        "IPS panel",
        "Interface: HDMI, DisplayPort, USB, Audio port"
    ],
    link: "/product/zus230gmg"
};

const TopSeller: React.FC = () => {
    return (
        <div 
            className="container w-[calc(100%-30px)] mx-auto mb-5 flex flex-col md:flex-row items-center gap-8 cursor-pointer"    
        >
            <img 
                className="rounded-lg"
                src={topSeller.image} 
                alt={topSeller.name} 
                style={{ maxInlineSize: '100%', height: 'auto' }} 
            />
            {/* <div className="text-left">
                <h2 className="text-2xl font-bold">{topSeller.name}</h2>
                <ul className="mt-4 space-y-1 text-gray-700">
                    {topSeller.features.map((feature, index) => (
                        <li key={index}>- {feature}</li>
                    ))}
                </ul>
                <a 
                    href={topSeller.link} 
                    className="mt-4 inline-block bg-orange-500 text-white px-4 py-2 rounded hover:bg-orange-600"
                >
                    More Details
                </a>
            </div> */}
        </div>
    );
};

export default TopSeller;
